<div class="!flex !flex-col !gap-4">
    <header class="!flex !flex-col !gap-3 sm:!flex-row sm:!items-center sm:!justify-between">
        <div class="!max-w-2xl">
            <h2 class="!mb-0 !text-lg !font-extrabold !tracking-tight !text-strong">Utenti della società</h2>
            <p class="!mb-0 !mt-0.5 !text-sm !text-subtle">
                L'amministratore può aprire i dettagli per vedere documenti e dati di onboarding.
            </p>
        </div>
        <button type="button"
                (click)="addPerson.emit()"
                class="!m-0 !inline-flex !shrink-0 !items-center !justify-center !gap-2 !rounded-xl !border-0 !bg-primary !px-3.5 !py-2 !text-sm !font-bold !text-white hover:!bg-secondary">
            <i class="bi bi-plus-lg" aria-hidden="true"></i>
            Aggiungi una persona
        </button>
    </header>

    <div *ngIf="loading" class="!flex !flex-col !gap-3" role="status" aria-label="Caricamento utenti">
        <section *ngFor="let card of skeletonCards"
                 class="!rounded-xl !border !border-solid !border-border !bg-white !px-4 !py-3">
            <div class="!flex !items-center !gap-3">
                <div class="!h-10 !w-10 !shrink-0 !animate-pulse !rounded-xl !bg-slate-200"></div>
                <div class="!flex !flex-1 !flex-col !gap-1.5">
                    <div class="!h-4 !w-48 !animate-pulse !rounded !bg-slate-200"></div>
                    <div class="!h-3 !w-64 !max-w-full !animate-pulse !rounded !bg-slate-200"></div>
                </div>
            </div>
        </section>
    </div>

    <div *ngIf="!loading && users.length === 0"
         class="!rounded-2xl !border !border-solid !border-border !bg-white !px-5 !py-12 !text-center">
        <div class="!mx-auto !flex !h-12 !w-12 !items-center !justify-center !rounded-full !bg-slate-100 !text-slate-400">
            <i class="bi bi-people" aria-hidden="true"></i>
        </div>
        <p class="!mb-1 !mt-4 !text-sm !font-semibold !text-strong">Non c'è ancora nessun accesso</p>
        <p class="!mb-0 !mx-auto !max-w-md !text-sm !text-subtle">
            Aggiungi la prima persona così può entrare nell'area riservata.
        </p>
    </div>

    <div *ngIf="!loading && users.length > 0" class="!flex !flex-col !gap-3">
        <article *ngFor="let row of sortedUsers; let i = index"
                 class="!overflow-hidden !rounded-xl !border !border-solid !border-border !bg-white">
            <div class="!flex !items-center !gap-3 !px-4 !py-3">
                <div class="!flex !h-10 !w-10 !shrink-0 !items-center !justify-center !rounded-xl !bg-primary-soft !text-xs !font-bold !text-primary">
                    {{ initials(row) }}
                </div>
                <div class="!min-w-0 !flex-1">
                    <div class="!flex !flex-wrap !items-center !gap-1.5">
                        <h3 class="!mb-0 !truncate !text-sm !font-bold !leading-tight !text-strong">
                            {{ row.firstName }} {{ row.lastName }}
                        </h3>
                        <span class="!inline-flex !rounded-full !bg-primary-soft !px-2 !py-0 !text-[10px] !font-bold !uppercase !tracking-wide !text-primary">
                            {{ roleName(row.userGroupId) }}
                        </span>
                        <span *ngIf="isManager(row)"
                              class="!inline-flex !rounded-full !bg-amber-50 !px-2 !py-0 !text-[10px] !font-bold !uppercase !tracking-wide !text-amber-700">
                            Rappresentante
                        </span>
                    </div>
                    <p class="!mb-0 !mt-0.5 !truncate !text-sm !text-subtle">{{ row.email || '—' }}</p>
                </div>
                <div class="!flex !shrink-0 !items-center !gap-1">
                    <button type="button"
                            class="!m-0 !inline-flex !h-8 !items-center !justify-center !gap-1.5 !rounded-lg !border !border-solid !border-slate-200 !bg-white !px-2.5 !text-xs !font-semibold !text-slate-700 hover:!bg-slate-50"
                            (click)="toggleExpanded(row, i)"
                            [attr.aria-expanded]="isExpanded(row, i)">
                        {{ isExpanded(row, i) ? 'Chiudi' : 'Vedi altro' }}
                        <i class="bi" [ngClass]="isExpanded(row, i) ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
                    </button>
                    <button type="button"
                            *ngIf="isSuperAdmin && row.id"
                            class="!m-0 !inline-flex !h-8 !w-8 !items-center !justify-center !rounded-lg !border !border-solid !border-slate-200 !bg-white !text-slate-500 hover:!bg-slate-50 hover:!text-slate-800"
                            (click)="loginAs.emit(row)"
                            [attr.aria-label]="'Accedi come ' + (row.email || row.firstName || 'utente')"
                            title="Accedi come utente">
                        <i class="bi bi-box-arrow-in-right" aria-hidden="true"></i>
                    </button>
                    <button type="button"
                            class="!m-0 !inline-flex !h-8 !w-8 !items-center !justify-center !rounded-lg !border !border-solid !border-slate-200 !bg-white !text-slate-500 hover:!bg-slate-50 hover:!text-slate-800"
                            (click)="editPerson.emit(row)"
                            [attr.aria-label]="'Modifica accesso di ' + (row.email || '')"
                            title="Modifica accesso">
                        <i class="bi bi-pencil" aria-hidden="true"></i>
                    </button>
                    <button type="button"
                            *ngIf="users.length > 1"
                            class="!m-0 !inline-flex !h-8 !w-8 !items-center !justify-center !rounded-lg !border !border-solid !border-red-100 !bg-red-50 !text-red-700 hover:!bg-red-100"
                            (click)="removePerson.emit(row.id!)"
                            [attr.aria-label]="'Rimuovi ' + (row.email || '')"
                            title="Rimuovi dalla società">
                        <i class="bi bi-trash" aria-hidden="true"></i>
                    </button>
                </div>
            </div>

            <div *ngIf="isExpanded(row, i)" class="!border-t !border-solid !border-slate-100 !px-4 !py-4">
                <dl class="!mb-0 !grid !grid-cols-1 !gap-x-6 !gap-y-3 sm:!grid-cols-2 lg:!grid-cols-4">
                    <div class="!min-w-0">
                        <dt class="!text-xs !font-semibold !uppercase !tracking-wide !text-slate-400">Telefono</dt>
                        <dd class="!mb-0 !truncate !text-sm !text-strong">{{ row.phone || '—' }}</dd>
                    </div>
                    <div class="!min-w-0">
                        <dt class="!text-xs !font-semibold !uppercase !tracking-wide !text-slate-400">Codice fiscale</dt>
                        <dd class="!mb-0 !truncate !text-sm !uppercase !text-strong">{{ row.fiscalCode || (isManager(row) ? company.legalFiscalCode : '') || '—' }}</dd>
                    </div>
                    <div class="!min-w-0">
                        <dt class="!text-xs !font-semibold !uppercase !tracking-wide !text-slate-400">N° documento</dt>
                        <dd class="!mb-0 !truncate !text-sm !uppercase !text-strong">{{ row.documentNumber || (isManager(row) ? company.legalDocumentNumber : '') || '—' }}</dd>
                    </div>
                    <div class="!min-w-0" *ngIf="statusLabel(row.status)">
                        <dt class="!text-xs !font-semibold !uppercase !tracking-wide !text-slate-400">Stato</dt>
                        <dd class="!mb-0 !text-sm !text-strong">{{ statusLabel(row.status) }}</dd>
                    </div>
                    <div class="!min-w-0" *ngIf="formatDate(row.lastAccess)">
                        <dt class="!text-xs !font-semibold !uppercase !tracking-wide !text-slate-400">Ultimo accesso</dt>
                        <dd class="!mb-0 !text-sm !text-strong">{{ formatDate(row.lastAccess) }}</dd>
                    </div>
                </dl>

                <div *ngIf="showDocuments(row)" class="!mt-4 !flex !flex-col !gap-4">
                    <div>
                        <h4 class="!mb-2 !text-sm !font-bold !text-strong">Documenti di identità</h4>
                        <div class="!grid !grid-cols-1 !gap-3 sm:!grid-cols-2">
                            <div *ngFor="let doc of identityDocumentsFor(row)"
                                 class="!flex !min-h-[7.5rem] !flex-col !items-center !justify-center !gap-1.5 !rounded-2xl !border !border-dashed !border-slate-200 !bg-slate-50 !px-3 !py-4 !text-center"
                                 [class.!border-solid]="!!doc.url"
                                 [class.!bg-primary-soft]="!!doc.url">
                                <p class="!mb-0 !text-xs !font-semibold !text-slate-500">{{ doc.label }}</p>
                                <ng-container *ngIf="doc.url; else missingIdentityDoc">
                                    <img *ngIf="!isPdf(doc.url)" [src]="doc.url" [alt]="doc.label"
                                         class="!h-16 !w-24 !rounded-lg !border !border-solid !border-slate-200 !object-cover"/>
                                    <i *ngIf="isPdf(doc.url)" class="bi bi-file-earmark-pdf-fill !text-2xl !text-primary" aria-hidden="true"></i>
                                    <a [href]="doc.url" target="_blank" rel="noopener"
                                       class="!text-xs !font-semibold !text-primary">
                                        {{ isPdf(doc.url) ? fileName(doc.url) : 'Apri documento' }}
                                    </a>
                                </ng-container>
                                <ng-template #missingIdentityDoc>
                                    <i class="bi bi-image !text-xl !text-slate-300" aria-hidden="true"></i>
                                    <span class="!text-xs !text-slate-400">Non caricato</span>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h4 class="!mb-2 !text-sm !font-bold !text-strong">Codice fiscale</h4>
                        <div class="!grid !grid-cols-1 !gap-3 sm:!grid-cols-2">
                            <div *ngFor="let doc of fiscalDocumentsFor(row)"
                                 class="!flex !min-h-[7.5rem] !flex-col !items-center !justify-center !gap-1.5 !rounded-2xl !border !border-dashed !border-slate-200 !bg-slate-50 !px-3 !py-4 !text-center"
                                 [class.!border-solid]="!!doc.url"
                                 [class.!bg-primary-soft]="!!doc.url">
                                <p class="!mb-0 !text-xs !font-semibold !text-slate-500">{{ doc.label }}</p>
                                <ng-container *ngIf="doc.url; else missingFiscalDoc">
                                    <img *ngIf="!isPdf(doc.url)" [src]="doc.url" [alt]="doc.label"
                                         class="!h-16 !w-24 !rounded-lg !border !border-solid !border-slate-200 !object-cover"/>
                                    <i *ngIf="isPdf(doc.url)" class="bi bi-file-earmark-pdf-fill !text-2xl !text-primary" aria-hidden="true"></i>
                                    <a [href]="doc.url" target="_blank" rel="noopener"
                                       class="!text-xs !font-semibold !text-primary">
                                        {{ isPdf(doc.url) ? fileName(doc.url) : 'Apri documento' }}
                                    </a>
                                </ng-container>
                                <ng-template #missingFiscalDoc>
                                    <i class="bi bi-image !text-xl !text-slate-300" aria-hidden="true"></i>
                                    <span class="!text-xs !text-slate-400">Non caricato</span>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </div>
</div>
